(function () {
    "use strict";

    angular.module("sempraWebapp").controller("VouchersController", VouchersController);

    /** @ngInject */
    function VouchersController($scope, $timeout, $translate, VouchersViewModel, voucherActions, dialogsService, userActions, sessionData) {
        var vm = this;

        vm.vouchers = new VouchersViewModel();
        vm.hasErrors = false;
        vm.hasNewVouchersErrors = false;
        vm.noFoundVouchersForPrint = false;
        vm.vouchersForPrint = [];
        vm.createLocalTokens = createLocalTokens;
        vm.createVouchers = createVouchers;
        vm.printVoucher = printVoucher;
        vm.printVouchers = printVouchers;
        vm.filterVouchers = filterVouchers;
        vm.createAndPrintVouchers = createAndPrintVouchers;
        vm.newVouchersBatch = {
            size: 1000
        };
        vm.issuedDateLabel = $translate.instant('ISSUED_DATE');
        vm.daysLabel = $translate.instant('VOUCHER_VALIDITY_DAYS');
        vm.expiryDateLabel = $translate.instant('EXPIRY_DATE');
        
        // Company voucher expiration days (loaded from backend)
        var companyVoucherExpirationDays; // Default vrednost
        var restrictedUsers = [
            'gsVidikovac@hellenic-petroleum.rs',
            'gsBistrica1@hellenic-petroleum.rs',
            'gsPalilula@hellenic-petroleum.rs',
            'gsBistrica2@hellenic-petroleum.rs',
            'gsKaludjerica@hellenic-petroleum.rs',
            'gsKikinda@hellenic-petroleum.rs',
            'gsSubotica@hellenic-petroleum.rs',
            'gsNis@hellenic-petroleum.rs',
            'gsVranje@hellenic-petroleum.rs',
            'gsZrenjanin@hellenic-petroleum.rs',
            'gsPancevackiPut@hellenic-petroleum.rs',
            'gsBorca@hellenic-petroleum.rs',
            'gsNBeograd@hellenic-petroleum.rs',
            'gsLeskovac@hellenic-petroleum.rs',
            'gsGMilanovac@hellenic-petroleum.rs',
            'gsKraljevo@hellenic-petroleum.rs',
            'gsProkuplje@hellenic-petroleum.rs',
            'gsGagarin@hellenic-petroleum.rs',
            'gsNis3@hellenic-petroleum.rs',
            'gsPirot@hellenic-petroleum.rs'
        ];
        // Check if user is test@test.com to disable certain fields
        var userEmail = sessionData.getValue(sessionData.Keys.USERNAME_KEY);
        vm.isRestrictedUser = restrictedUsers.includes(userEmail);

        // news table sort
        vm.sortChanged = function (order) {
            vm.vouchers.sortChanged(order);
            getVouchersHistory();
        };

        // news pagination
        vm.pageChanged = function (page, limit) {
            vm.vouchers.paginationChanged(page, limit);
            getVouchersHistory();
        };

        //Download CSV with vouchers
        vm.downloadCSV = function (seriesPrefix) {
            voucherActions.vouchersToCSV(seriesPrefix).then(function (data) {
                var csv = data;
                /* eslint-disable */
                var hiddenElement = document.createElement("a");
                /* eslint-enable */
                hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
                hiddenElement.target = "_blank";
                hiddenElement.download = "vouchers.csv";
                hiddenElement.click();
            });
        };

        //After close print window, hidden qrCode list Div
        /* eslint-disable */
        // window.onafterprint = function() {
        //     location.reload();
        // };
        /* eslint-enable */

        init();

        function init() {
            $scope.$on("$destroy", onDestroyHandler);
            getVouchersHistory();
            
            // Load company details to get default voucherExpirationDays
            userActions.getCompanyDetails().then(function(companyData) {
                if (companyData.voucherExpirationDays) {
                    companyVoucherExpirationDays = companyData.voucherExpirationDays;
                    vm.vouchers.voucherValidityDays = companyData.voucherExpirationDays.toString();
                }
            });
        }

        function onDestroyHandler() {
            vm.vouchers.destroy();
        }

        function printVouchers(voucherSeries) {
            vm.vouchers.vouchersForPrint = [];
            vm.noFoundVouchersForPrint = false;
            voucherActions
                .getVouchersHistory(0, vm.newVouchersBatch.size, "issuedAt", "desc", voucherSeries)
                .then(function (data) {
                    vm.vouchers.vouchersForPrint = data;
                    vm.vouchersForPrint = [];
                    vm.vouchersForPrint = vm.vouchers.vouchersForPrint.content.map(function(voucher) {
                        if (voucher.expiresAt && voucher.issuedAt) {
                            var issuedDate = new Date(voucher.issuedAt);
                            var expiresDate = new Date(voucher.expiresAt);
                            var issuedUTC = Date.UTC(issuedDate.getUTCFullYear(), issuedDate.getUTCMonth(), issuedDate.getUTCDate());
                            var expiresUTC = Date.UTC(expiresDate.getUTCFullYear(), expiresDate.getUTCMonth(), expiresDate.getUTCDate());
                            var diffTime = expiresUTC - issuedUTC;
                            voucher.validityDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
                        }
                        return voucher;
                    });
                    vm.noFoundVouchersForPrint = vm.vouchersForPrint.length > 0 ? false : true;
                    if (!vm.noFoundVouchersForPrint) {
                        print();
                    }
                });
        }

        function printVoucher(voucher) {
            vm.vouchersForPrint = [];
            if (!voucher.validityDays && voucher.expiresAt && voucher.issuedAt) {
                var issuedDate = new Date(voucher.issuedAt);
                var expiresDate = new Date(voucher.expiresAt);
                var issuedUTC = Date.UTC(issuedDate.getUTCFullYear(), issuedDate.getUTCMonth(), issuedDate.getUTCDate());
                var expiresUTC = Date.UTC(expiresDate.getUTCFullYear(), expiresDate.getUTCMonth(), expiresDate.getUTCDate());
                var diffTime = expiresUTC - issuedUTC;
                voucher.validityDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
            }
            vm.vouchersForPrint.push(voucher);
            print();
        }

        function print() {
            $timeout(function () {
                /* eslint-disable */
                window.print();
                /* eslint-enable */
            }, 0);
        }

        function createLocalTokens(form) {
            vm.form = form;
            vm.hasErrors = false;
            // To disable multiple pressed button issue
            vm.disableButton = true;
            // ========================================
            voucherActions.createLocalTokens(vm.vouchers.email.toLowerCase(), vm.vouchers.amount).then(
                function () {
                    vm.vouchers.onTokensCreatedSuccessHandler();
                    vm.form.$setUntouched();
                    vm.form.$setPristine();
                    vm.disableButton = false;
                    getVouchersHistory();
                },
                function () {
                    vm.hasErrors = true;
                }
            );
        }

        // Helper funkcija za kreiranje i štampanje vaučera
        function executeCreateAndPrintVouchers() {
            return voucherActions
                .createAndRetrieveVouchers(
                    vm.vouchers.amountOfTokens,
                    vm.vouchers.amountOfVouchers,
                    vm.vouchers.newVoucherPrefix,
                    parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays
                )
                .then(function (data) {
                    vm.vouchers.onVouchersCreatedSuccessHandler();
                    vm.form.$setUntouched();
                    vm.form.$setPristine();
                    vm.vouchersForPrint = [];
                    // Dodaj validityDays u svaki voucher za štampu
                    var expireDays = parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays;
                    vm.vouchersForPrint = data.map(function(voucher) {
                        voucher.validityDays = expireDays;
                        return voucher;
                    });
                    vm.noFoundVouchersForPrint = vm.vouchersForPrint.length > 0 ? false : true;
                    if (!vm.noFoundVouchersForPrint) {
                        print();
                    }
                })
                .then(function () {
                    getVouchersHistory();
                })
                .catch(function (error) {
                    // error handler
                    dialogsService.showOkDialog("API_ERROR", error.data.message).then();
                    console.error('API greška:', error.data.message);
                });
        }

        function createAndPrintVouchers(form) {
            vm.form = form;
            // Za restricted usere preskačemo dialog i odmah kreiramo vaučere
            if (vm.vouchers.newVoucherPrefix == "" && vm.vouchers.amountOfVouchers > 10 && !vm.isRestrictedUser) {
                dialogsService.showConfirmDialog("CODE_PREFIX_QUESTION", "CODE_PREFIX_QUESTION_TEXT", "PROCEED").then(function () {
                    executeCreateAndPrintVouchers();
                });
            } else if (vm.vouchers.newVoucherPrefix != "") {
                voucherActions
                    .getVouchersHistory(
                        vm.vouchers.page - 1,
                        vm.vouchers.pageSize,
                        vm.vouchers.orderBy,
                        vm.vouchers.order,
                        vm.vouchers.newVoucherPrefix
                    )
                    .then(function (res) {
                        var checkVoucherExistence = res.content.length > 0;
                        if (!checkVoucherExistence) {
                            // Ako ne postoje, kreiraj ih
                            return voucherActions.createAndRetrieveVouchers(
                                vm.vouchers.amountOfTokens,
                                vm.vouchers.amountOfVouchers,
                                vm.vouchers.newVoucherPrefix,
                                parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays
                            );
                        } else {
                            // Ako postoje, prikaži dijalog i prekini
                            return dialogsService.showOkDialog("CODE_PREFIX_EXIST", "CODE_PREFIX_EXIST_TEXT");
                        }
                    })
                    .then(function (data) {
                        vm.vouchers.onVouchersCreatedSuccessHandler();
                        vm.form.$setUntouched();
                        vm.form.$setPristine();
                        vm.vouchersForPrint = [];
                        // Dodaj validityDays u svaki voucher za štampu
                        var expireDays = parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays;
                        vm.vouchersForPrint = data.map(function(voucher) {
                            voucher.validityDays = expireDays;
                            return voucher;
                        });
                        vm.noFoundVouchersForPrint = vm.vouchersForPrint.length > 0 ? false : true;
                        if (!vm.noFoundVouchersForPrint) {
                            print();
                        }
                    })
                    .then(function () {
                        getVouchersHistory();
                    })
                    .catch(function (error) {
                        // error handler
                        dialogsService.showOkDialog("API_ERROR", error.data.message).then();
                        console.error('API greška:', error.data.message);
                    });
            } else {
                // Za restricted usere ili kada je prefix prazan i broj vaučera <= 10
                executeCreateAndPrintVouchers();
            }

        }

        function createVouchers(form) {
            voucherActions
                .getVouchersHistory(
                    vm.vouchers.page - 1,
                    vm.vouchers.pageSize,
                    vm.vouchers.orderBy,
                    vm.vouchers.order,
                    vm.vouchers.newVoucherPrefix
                )
                .then(function (res) {
                    var checkVoucherExistence = res.content.length > 0;
                    if (!checkVoucherExistence) {
                        createNewVoucher(form);
                    } else {
                        dialogsService.showOkDialog("CODE_PREFIX_EXIST", "CODE_PREFIX_EXIST_TEXT").then();
                    }
                });


        }

        function createNewVoucher(form) {
            vm.form = form;
            vm.hasNewVouchersErrors = false;
            voucherActions
                .createVouchers(
                    vm.vouchers.amountOfTokens,
                    vm.vouchers.amountOfVouchers,
                    vm.vouchers.newVoucherPrefix,
                    parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays
                )
                .then(
                    function () {
                        vm.vouchers.onVouchersCreatedSuccessHandler();
                        vm.form.$setUntouched();
                        vm.form.$setPristine();
                        getVouchersHistory();
                    },
                    function (error) {
                        vm.errorMessage = error.data;
                        vm.hasNewVouchersErrors = true;
                    }
                );
        }

        function getVouchersHistory() {
            if (vm.vouchers.orderBy.indexOf("-") > -1) {
                vm.vouchers.orderBy = vm.vouchers.orderBy.substring(1);
            }

            vm.promise = voucherActions
                .getVouchersHistory(
                    vm.vouchers.page - 1,
                    vm.vouchers.pageSize,
                    vm.vouchers.orderBy,
                    vm.vouchers.order,
                    vm.vouchers.voucherCodeFilter
                )
                .then(refreshVouchersHistory);
        }

        function filterVouchers() {
            vm.vouchers.page = 1;
            getVouchersHistory();
        }

        function refreshVouchersHistory(data) {
            vm.vouchers.refreshVouchersHistory(data);
        }
    }
})();
